<template>
  <div class="culture">
    <div class="culture-upper com-padding-top-90 com-padding-bottom-90">
      <div class="com-content-1560 com-content">
        <div class="dn-lower">
          <div class="swiper-container swiper1">
            <div class="swiper-wrapper wrapper1">
              <div class="swiper-slide slide1"
                   v-for="(item, index) in dataHomeblock" :key="index">
                <div class="dp-picture">
                  <img :src="stateimgBaseURL+item.imga_path" alt=""
                       class="dp-img1 com-size-all com-object-fit-cover">
                </div>
                <div class="dp-word">
                  <div class="dp-ti1">{{ item.title }}</div>
                  <div class="dp-p1">{{ item.recom }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="culture-lower com-padding-top-120 com-padding-bottom-90">
      <img :src="stateimgBaseURL+bgimg" alt=""
           class="dp-bgimg1 com-size-all com-position-absolute-start com-object-fit-cover">
      <div class="com-content-1560">
        <el-timeline class="el-timeline1">
          <el-timeline-item
              v-for="(item, index) in activities" :key="index">
            {{ item.title }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      dataHomeblock: [],
      bgimg: '',
      activities: []
    }
  },
  computed: {
    ...mapState(['stateimgBaseURL'])
  },
  created() {
    this.dataRequestbrandstore_brandCulture()
    this.dataRequestbrandstore_globalLayout()
  },
  methods: {
    // 品牌文化
    dataRequestbrandstore_brandCulture() {
      this.$api.user.brandstore_brandCulture().then(res => {
        this.dataHomeblock = res.data.list
        this.activities=res.data.text
      })
    },
    // 全球布局
    dataRequestbrandstore_globalLayout() {
      this.$api.user.brandstore_globalLayout().then(res => {
        this.bgimg = res.data.info.imgb_path
      })
    },
  }
}
</script>

<style scoped lang="scss">
.culture-upper {
  .dn-lower {
    .swiper1 {
      overflow: visible;

      .wrapper1 {
        justify-content: space-around;
        flex-wrap: wrap;
      }

      .slide1 {
        text-align: center;
        width: auto;

        &:hover {
          .dp-picture {
            transform: translateY(-10px);
          }
          .dp-word{
           *{
             color: $color2 !important;
           }
          }
        }

        .dp-picture {
          width: 168px;
          height: 168px;
          border-radius: 50%;
          overflow: hidden;
          margin: auto;
          transition: all .3s ease;
        }

        .dp-word {
          .dp-ti1 {
            color: #000000;
            font-size: 18px;
            margin: 20px 0;
          }

          .dp-p1 {
            color: #999999;
            font-size: 16px;
          }
        }
      }
    }
  }
}

.culture-lower {
  position: relative;

  .el-timeline1 {
    ::v-deep .el-timeline-item__content {
      color: #ffffff;
    }

  }
}

@media screen and (max-width: 768px) {
  .culture-upper {
    .dn-lower {
      .swiper1 {
        .slide1 {
          width: calc(100% / 2 - 4%);
          margin: calc(4% / 2);

          .dp-picture {
            width: 180*$mobile-conversion;
            height: 180*$mobile-conversion;
          }

          .dp-word {
            .dp-ti1 {
              font-size: 28*$mobile-conversion;
              margin: 20*$mobile-conversion 0;
            }

            .dp-p1 {
              font-size: 26*$mobile-conversion;
            }
          }
        }
      }
    }
  }
}
</style>
